import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customerIds: "",
  siteIds: "",
  countryIds: "",
  state: "",
  region: ""
};

const DashboardWidgetsFeatures = createSlice({
  name: "DashboardWidgetsPage",
  initialState,
  reducers: {
    //#region Set individual objects
    setCountryIds(state, action) {
      return {
        ...state,
        countryIds: action.payload,
      };
    },
    setStateIds(state, action) {
      return {
        ...state,
        stateIds: action.payload,
      };
    },
    setRegionIds(state, action) {
      return {
        ...state,
        regionIds: action.payload,
      };
    },
    setCustomerIds(state, action) {
      return {
        ...state,
        customerIds: action.payload,
      };
    },
    setSiteIds(state, action) {
      return {
        ...state,
        siteIds: action.payload,
      };
    },
    //#endregion

    //Reset to initialState
    resetDashboardWidgetsStates() {
      return {
        ...initialState,
      };
    },
  },
});

export const DashboardWidgetsActions = DashboardWidgetsFeatures.actions;
export default DashboardWidgetsFeatures.reducer;
